import React from 'react';
import { IconProps } from '../Icons/IconProps';

export const BokunLogo = ({ scale = 1 }: IconProps): JSX.Element => {
    return (
        <svg
            width={125 * scale}
            height={56 * scale}
            viewBox="0 0 125 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.9894 47.1431C21.9894 49.2529 21.1679 51.2542 19.7368 52.6491C18.3434 54.0787 16.4112 54.9725 13.2301 54.9725H0V30.1963L11.2633 30.1602C14.5528 30.1602 16.053 30.9456 17.5202 32.4128C18.9498 33.8785 19.3786 35.63 19.3786 37.669C19.3786 39.3845 18.8429 40.5281 18.2711 41.0292C18.6277 41.0653 19.2011 41.2428 19.7368 41.7801C21.2386 43.2819 21.9894 44.9973 21.9894 47.1431ZM6.82556 35.8798V39.4913H10.3302C11.0811 39.4913 11.5822 39.2415 11.8681 38.9556C12.1886 38.6336 12.4038 38.1686 12.4038 37.669C12.4038 36.6668 11.6168 35.8798 10.6161 35.8798H6.82556ZM14.4428 47.1431C14.4428 46.1063 13.5836 45.2832 12.5829 45.2832H6.82556V49.0738H12.1179C13.0118 49.0738 13.549 48.824 13.8695 48.502C14.2276 48.1438 14.4428 47.6804 14.4428 47.1431Z"
                fill="#34404E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M99.2311 30.2217V45.3102C99.2311 48.2415 98.1943 50.8162 96.1207 52.8552C94.0472 54.9288 91.5086 56.0001 88.5412 56.0001C85.6099 56.0001 83.1058 54.9288 80.9961 52.8552C78.9225 50.8162 77.8857 48.2415 77.8857 45.3102V30.2217H85.6099V45.3102C85.6099 46.9549 86.931 48.2415 88.5412 48.2415C90.1859 48.2415 91.5086 46.9549 91.5086 45.3102V30.2217H99.2311Z"
                fill="#34404E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M124.16 54.9711H116.544L116.472 55.0073L108.5 43.5303V54.9711H100.812V30.1934L108.5 30.1572L116.437 41.4567V30.1572H124.16V54.9711Z"
                fill="#34404E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M75.6669 30.1572H65.9525L59.2557 38.7375V30.1572H51.5332V42.5642V54.9711H59.2557V46.3893L65.9525 54.9711H75.6669L66.2839 42.5642L75.6669 30.1572Z"
                fill="#34404E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M45.7833 52.0401C43.1725 54.6148 40.0637 55.9375 36.3799 55.9375C32.6977 55.9375 29.5873 54.6148 26.9765 52.0401C24.4018 49.4293 23.0791 46.2844 23.0791 42.6367C23.0791 38.9545 24.4018 35.808 26.9765 33.2333C29.5873 30.6225 32.6977 29.2998 36.3799 29.2998C40.0637 29.2998 43.1725 30.6225 45.7833 33.2333C48.3941 35.808 49.7168 38.9545 49.7168 42.6367C49.7168 46.2844 48.3941 49.4293 45.7833 52.0401ZM40.3134 38.7032C39.2044 37.5957 37.9178 37.0585 36.3799 37.0585C34.8059 37.0585 33.5193 37.5957 32.4102 38.7032C31.3389 39.7761 30.8016 41.0988 30.8016 42.6367C30.8016 44.1746 31.3389 45.4973 32.4102 46.6048C33.5193 47.6777 34.8059 48.2134 36.3799 48.2134C37.9178 48.2134 39.2044 47.6777 40.3134 46.6048C41.457 45.4973 41.9927 44.1746 41.9927 42.6367C41.9927 41.0988 41.457 39.7761 40.3134 38.7032Z"
                fill="#34404E"
            />
            <mask id="mask0" maskUnits="userSpaceOnUse" x="52" y="0" width="72" height="27">
                <path d="M123.883 0H52.002V26.5364H123.883V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M120.668 24.1777L108.127 13.2694L99.231 18.5083L105.006 14.4617L89.0076 0L75.1978 14.0093L76.8441 11.4644L74.6873 9.38297L69.5442 13.7077L66.9601 12.8814L52.002 26.5372H123.883L120.668 24.1777ZM108.287 15.0916L112.229 18.2821L109.905 18.3497L108.187 20.1798L108.144 17.9444L99.6819 20.1326H99.6426L108.287 15.0916ZM88.8914 2.89988L94.4445 10.2501C94.4445 10.2501 91.3703 8.59595 91.1692 8.82059C90.9681 9.04523 86.235 14.9 86.235 14.9L85.9679 11.4409L85.0254 13.3636L84.8919 11.6325L75.9582 16.1017L88.8914 2.89988ZM67.3355 14.3439L68.8498 15.9085L73.7715 11.9545L72.155 15.4781L71.6021 14.9581L66.5485 20.5882C66.5485 20.5882 66.5343 19.853 66.5281 19.586C66.5249 19.3173 64.9085 20.1012 64.9085 20.1012L66.4762 16.8479L63.2307 17.5438L67.3355 14.3439Z"
                    fill="#1D57C7"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44.0334 20.9316L38.2886 26.5319H33.1816L38.2886 20.9316H44.0334Z"
                fill="#34404E"
            />
        </svg>
    );
};
